import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import LinkButton from '@/components/link_button/Index.vue';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import DateMixin from '@/helpers/mixins/DateMixin';
import Avatar from '@/components/avatar/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { DATETIME_DISPLAY_FORMAT } from '../../../helpers/constants/app';
let SalesAmountList = class SalesAmountList extends Mixins(RouterParamsAppMixin, DateMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.headers = [
            {
                text: 'PRODUCT',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DATE OF PURCHASE',
                value: 'createdAt',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CUSTOMER',
                value: 'pageRecipient',
                align: 'left',
                sortable: false,
            },
            {
                text: 'SUBTOTAL',
                value: 'quantity',
                align: 'right',
                sortable: false,
            },
        ];
    }
    parsedDate(date) {
        return this.formatDate(DATETIME_DISPLAY_FORMAT, date.toString());
    }
};
__decorate([
    Prop()
], SalesAmountList.prototype, "latestSoldProducts", void 0);
SalesAmountList = __decorate([
    Component({
        components: {
            ActionButton,
            LinkButton,
            Avatar,
        },
    })
], SalesAmountList);
export default SalesAmountList;
